
import React from "react";

interface ProfileBioDisplayProps {
  bio: string;
}

export const ProfileBioDisplay = ({ bio }: ProfileBioDisplayProps) => {
  return (
    <div className="prose prose-emerald max-w-none">
      {bio ? (
        <p className="text-gray-700 whitespace-pre-line">{bio}</p>
      ) : (
        <p className="text-gray-400 italic">No bio information added yet. Click edit to add your professional bio.</p>
      )}
    </div>
  );
};
